import { getRoot } from "mobx-state-tree"

export const holidayHoursFactoryViews = self => ({

})